<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="Metabase" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { MetabaseProps } from './Metabase.ts';
import Metabase from './Metabase.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';
import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-metabase';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<MetabaseProps>();
const changableProps = useChangableProps(componentName, props);
</script>
